var scroll = $(document).scrollTop();
var navHeight = $('.navbar').outerHeight();

$(window).scroll(function () {
    var scrolled = $(document).scrollTop();
    // console.log("scrolled" + scrolled);
    // console.log("navHeight" + navHeight);
    // console.log(scroll);

    if (scrolled < 10) {
        // console.log("menu hide");
        $('.navbar').addClass("normal__navbar");
    }
    else if (scroll > 10) {
        // console.log("menu show");
        $('.navbar').removeClass("normal__navbar");
    }

    if (scrolled > navHeight) {
        $('.navbar').removeClass("fixed-navbar");
        $('.filter-icon-container').addClass("filter-icon-container_active");
        $('.fixed-chat-icon').removeClass("hide-chat-icon");
        $('.navbar').removeClass("normal__navbar");
    }
    else {
        $('.navbar').addClass("fixed-navbar");
        $('.filter-icon-container').removeClass("filter-icon-container_active");
        $('.fixed-chat-icon').addClass("hide-chat-icon");
    }

    if (scrolled > scroll) {
        $('.navbar').addClass("fixed-navbar");
        $('.filter-icon-container').removeClass("filter-icon-container_active");
        $('.fixed-chat-icon').addClass("hide-chat-icon");
    }
    else {
        $('.navbar').removeClass("fixed-navbar");
        $('.filter-icon-container').addClass("filter-icon-container_active");
        $('.fixed-chat-icon').removeClass("hide-chat-icon");

    }

    scroll = $(document).scrollTop();
});

$(document).ready(function () {
    $("#ham-btn").click(function (e) {
        e.preventDefault();
        $(".menu-head").toggleClass("menu-active");
        $(this).toggleClass("btn-active");
        $(".navbar .logo").toggleClass("logo-active");
        $(".navbar").toggleClass("nav_overflow_no")
    });

    if ($(window).width() > 1200) {
        $(".has-sub-menu").mouseover(function () {
            $(this).find(".sub-menu").addClass("submenu-active");
            $(this).addClass("has-sub-menu-active");
            $(".navbar-bg").addClass("navbar-bg-active");
        });

        $(".has-sub-menu").mouseout(function () {
            $(this).find(".sub-menu").removeClass("submenu-active");
            $(this).removeClass("has-sub-menu-active");
            $(".navbar-bg").removeClass("navbar-bg-active");
        });
    }

    // if ($(window).width() < 1200) {
    //     $(".has-sub-menu .menu-list-link").click(function (e) {
    //         e.preventDefault();
    //         $(".has-sub-menu").addClass("has-sub-menu-active");
    //     });
    //     // mobile-curat-prod-btn
    //     $(".mobile-curat-prod-btn").click(function (e) {
    //         e.preventDefault();
    //         $(".has-sub-menu").removeClass("has-sub-menu-active");
    //     });

    //     $(".mob_col_btn").click(function (e) {
    //         e.preventDefault();
    //         $(".has-sub-menu").toggleClass("collection-mob-active");
    //     });

    //     $(".mob_cat_btn").click(function (e) {
    //         e.preventDefault();
    //         $(".has-sub-menu").toggleClass("category-mob-active");
    //     });

    //     $(".mob_collab_btn").click(function (e) {
    //         e.preventDefault();
    //         $(".has-sub-menu").toggleClass("collabration-mob-active");
    //     });

    // }

    $(".filter-btn").click(function (e) {
        e.preventDefault();
        $(".filter-side-nav").addClass("filter-side-nav-active");
    });

    $(".m_close").click(function (e) {
        e.preventDefault();
        $(".filter-side-nav").removeClass("filter-side-nav-active");
    });

    $(".filter-list .filter-list-items .filter-sub-nav .mobile-close-btn").click(function (e) {
        e.preventDefault();
        $(this).parents(".filter-list-items").removeClass("has-subnav");
    });
});
